import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    color: "#465869",
    fontWeight: 700,
    fontFamily: "Manrope",
    fontSize: 20,
  },
  text: {
    fontFamily: "Manrope",
    fontSize: "16px",
    marginBottom: "5px",
  },
  box: {
    marginBottom: "20px",
  },
  skeleton: {
    height: "175px",
    width: "100%",
  },
}));

export default styles;
